'use client';

import Slider, { Settings } from 'react-slick';
import { useEffect, useRef, ReactNode } from 'react';
import { CarouselArrows } from '@components/common/Carousel/CarouselArrows';
import 'styles/bj_theme/bj_slick_image_gallery.css';

interface ChatCardsCarouselProps {
  className?: string;
  items: ReactNode[];
  sliderSettings?: Settings;
}

const sliderSettings: Settings = {
  autoplay: false,
  autoplaySpeed: 3000,
  dots: false,
  arrows: true,
  infinite: false,
  slidesToShow: 3,
  rows: 1,
  slidesToScroll: 1,
  nextArrow: <CarouselArrows direction="next" />,
  prevArrow: <CarouselArrows direction="prev" />,
  className: 'bj-slick-image-gallery chat-cards-carousel',
  responsive: [
    {
      breakpoint: 960,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 1.15,
      },
    },
  ],
};

const ChatCardsCarousel = (props: ChatCardsCarouselProps) => {
  // Props destructuring
  const {
    className = '',
    items,
    sliderSettings: customSliderSettings,
  } = props;
  const sliderRef = useRef<Slider | null>(null);

  useEffect(() => {
    // React slick doesn't automatically start the autoplay when the props change
    if (customSliderSettings?.autoplay) {
      // Start autoplay if it's enabled in custom settings
      sliderRef.current?.slickPlay();
    } else {
      // Stop autoplay if it's disabled in custom settings
      sliderRef.current?.slickPause();
    }
  }, [customSliderSettings?.autoplay]);

  // Render the component
  // ********************************
  return (
    <div className={`relative ${className}`}>
      <Slider ref={sliderRef} {...sliderSettings} {...customSliderSettings}>
        {items?.map((item) => (
          <div className="!flex size-full justify-center">
            {item}
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default ChatCardsCarousel;
